/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { ILdsWarnViewProps } from './lds-warn';

//@ts-ignore
import { Warn } from '@churchofjesuschrist/eden-alert';

export default (props: ILdsWarnViewProps) => {
    const [isOpen, setIsOpen] = React.useState(true);

    const { textOne, textTwo, close, warnLink, link2, column, marginTop } = props.config;

    const onClose = () => {
        setIsOpen(!isOpen);
    };

    const link = (
        <a
            href={warnLink?.linkUrl.destinationUrl}
            style={{
                marginTop: '2px',
                alignSelf: link2 && link2.style === 'center' ? 'center' : link2 && link2.style !== 'center' ? `flex-${link2.style}` : ''
            }}
        >
            {warnLink?.linkText}
        </a>
    );
    const marginLength =
        marginTop && marginTop.style === 'small'
            ? '5px'
            : marginTop && marginTop.style === 'medium'
            ? '10px'
            : marginTop && marginTop.style === 'large'
            ? '20px'
            : '0px';
    if (isOpen) {
        return (
            <div style={{ width: '100%', display: 'flex', justifyContent: 'space-around', marginTop: marginLength }}>
                <Warn onClose={close ? () => onClose() : close} style={{ width: '100%', maxWidth: '960px' }}>
                    <div style={{ display: 'flex', flexDirection: column ? 'column' : 'row' }}>
                        <div style={{ marginTop: '3px', marginRight: '3px' }}>{textOne}</div>
                        {warnLink && warnLink.linkText && warnLink.linkUrl.destinationUrl && link}
                        <div style={{ marginTop: '3px', marginLeft: '3px' }}>{textTwo}</div>
                    </div>
                </Warn>
            </div>
        );
    } else {
        return <></>;
    }
};
